import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const HOUSE = {
  nickname: 'PRODUCTS.HOUSE.nickname',
  LIST_OF_OBJECTS: ['houseAdditionalBuildings', 'houseWithContents'],
  properties: [
    { name: 'productPackage', key: 'PRODUCT_PACKAGE_WTC', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      isRentalPropertiesCheck: true,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ELITE', value: 'SUPER' }
        ]
      }
    },
    { name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO' },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.5', value: 5000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.75', value: 7500 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.10', value: 10000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.15', value: 15000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.20', value: 20000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.25', value: 25000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.30', value: 30000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.50', value: 50000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.100', value: 100000 }
        ]
      }
    },
    { name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseIsRented', key: 'HOUSE_IS_RENTED_WTC', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      isRentalPropertiesCheck: true,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'objectZipCode', key: 'OBJECT_ZIP_CODE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]]
    },
    { name: 'houseBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.HOUSE', value: 'HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.TERRACED_HOUSE', value: 'TERRACED_HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.DUPLEX', value: 'DUPLEX' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.4_MANS_HOUSE', value: 'QUADRUPLEX' }
        ]
      }
    },
    { name: 'wtcBuildingValueStandard', key: 'BUILDING_VALUE_STANDARD', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_VALUE_STANDARD.NORMAL', value: 'Normal' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_VALUE_STANDARD.BETTER', value: 'Bedre' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_VALUE_STANDARD.HIGH_STANDARD', value: 'Svært høy standard' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_VALUE_STANDARD.EXCLUSIV', value: 'Eksklusiv' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_VALUE_STANDARD.UNDERWRITER', value: 'Underwriter' }
        ]
      }
    },
    { name: 'houseBuildingYear', key: 'BUILDING_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'houseSumInsuredType', key: 'SUM_INSURED_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      isFirstRiskSumInsuredCheck: true,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
        ]
      }
    },
    { name: 'houseFirstRiskSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
    { name: 'houseBuildingMaterials', key: 'BUILDING_MATERIALS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.MUR', value: 'MUR' },
        ]
      }
    },
    {
      name: 'wtcHouseownerPrimary', key: 'HOUSE_OWNER_PRIMARY', group: 'OBJECT_INFO',
      isRentalPropertiesCheck: true,
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMFireAlarmConnected', key: 'HOUSE_SM_FIRE_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMNoCella', key: 'HOUSE_SM_NO_CELLA_WTC', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseNumberOfBathrooms', key: 'HOUSE_NUMBER_OF_BATHROOMS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMBurglarAlarmConnected', key: 'HOUSE_SM_BURGAR_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMAutomaticWaterStop', key: 'HOUSE_SM_AUTOMATIC_WATER_STOP', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_AUTOMATIC_WATER_STOP.NO', value: 'Nei' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_AUTOMATIC_WATER_STOP.VANNALARM', value: 'Vannalarm' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_AUTOMATIC_WATER_STOP.VANNSTOPPVENTIL', value: 'Vannstoppventil' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_AUTOMATIC_WATER_STOP.VANNALARM_OG_VANNSTOPPVENTIL', value: 'Vannalarm og vannstoppventil' },
        ]
      }
    },
    {
      name: 'wtcHouseownerMorethan3Floors', key: 'HOUSE_OWNER_MORE_THAN_3_FLOORS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'wtcHouseownerBasementDry', key: 'HOUSE_OWNER_BASEMENT_DRY', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'wtcHouseownerMushroom', key: 'HOUSE_OWNER_MUSHROOM', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'wtcBuildingConstructionFactor', key: 'BUILDING_CONSTRUCTION_FACTOR', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]],
      disabled: true
    },
    // {
    //   name: 'wtcPreviousWaterDamage', key: 'WTC_PREVIOUS_WATER_DAMAGE', group: 'OBJECT_INFO',
    //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    //   validator: ['', [
    //     Validators.required
    //   ]],
    //   settings: {
    //     list: [
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.YES', value: 'Ja' },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.NO', value: 'Nei' },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.BLANK', value: 'Blank' },
    //     ]
    //   }
    // },
    // {
    //   name: 'wtcIntPipeRehab', key: 'WTC_INT_PIPE_REHAB', group: 'OBJECT_INFO',
    //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    //   validator: ['', [
    //     Validators.required
    //   ]],
    //   settings: {
    //     list: [
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.YES', value: 'Ja' },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.NO', value: 'Nei' },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.BLANK', value: 'Blank' },
    //     ]
    //   }
    // },
    // {
    //   name: 'wtcExtPipeRehab', key: 'WTC_EXT_PIPE_REHAB', group: 'OBJECT_INFO',
    //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    //   validator: ['', [
    //     Validators.required
    //   ]],
    //   settings: {
    //     list: [
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.YES', value: 'Ja' },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.NO', value: 'Nei' },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.BLANK', value: 'Blank' },
    //     ]
    //   }
    // },
    // {
    //   name: 'wtcIntInstallation', key: 'WTC_INT_INSTALLATION', group: 'OBJECT_INFO',
    //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    //   validator: ['', [
    //     Validators.required
    //   ]],
    //   settings: {
    //     list: [
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.YES', value: 'Ja' },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.NO', value: 'Nei' },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.BLANK', value: 'Blank' },
    //     ]
    //   }
    // },
    // {
    //   name: 'wtcRoofPipeRehab', key: 'WTC_ROOF_PIPE_REHUB', group: 'OBJECT_INFO',
    //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    //   validator: ['', [
    //     Validators.required
    //   ]],
    //   settings: {
    //     list: [
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.YES', value: 'Ja' },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.NO', value: 'Nei' },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.BLANK', value: 'Blank' },
    //     ]
    //   }
    // },
    // {
    //   name: 'wtcBuildDrainage', key: 'WTC_BUILD_DRAINAGE', group: 'OBJECT_INFO',
    //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    //   validator: ['', [
    //     Validators.required
    //   ]],
    //   settings: {
    //     list: [
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.YES', value: 'Ja' },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.NO', value: 'Nei' },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.BOOLEAN.BLANK', value: 'Blank' },
    //     ]
    //   }
    // },
    // {
    //   name: 'wtcOldestPipeSection', key: 'WTC_OLDEST_PIPE_SECTION', group: 'OBJECT_INFO',
    //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    //   validator: ['', [
    //     Validators.required
    //   ]],
    //   settings: {
    //     list: [
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.0', value: 0 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.1', value: 1 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.2', value: 2 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.3', value: 3 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.4', value: 4 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.5', value: 5 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.6', value: 6 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.7', value: 7 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.8', value: 8 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.9', value: 9 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.10', value: 10 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.11', value: 11 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.12', value: 12 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.13', value: 13 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.14', value: 14 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.15', value: 15 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.16', value: 16 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.17', value: 17 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.18', value: 18 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.19', value: 19 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.20', value: 20 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.21', value: 21 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.22', value: 22 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.23', value: 23 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.24', value: 24 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.25', value: 25 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.26', value: 26 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.27', value: 27 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.28', value: 28 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.29', value: 29 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.30', value: 30 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.31', value: 31 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.32', value: 32 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.33', value: 33 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.34', value: 34 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.35', value: 35 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.36', value: 36 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.37', value: 37 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.38', value: 38 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.39', value: 39 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.40', value: 40 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.41', value: 41 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.42', value: 42 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.43', value: 43 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.44', value: 44 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.45', value: 45 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.46', value: 46 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.47', value: 47 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.48', value: 48 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.49', value: 49 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.50', value: 50 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.51', value: 51 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.52', value: 52 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.53', value: 53 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.54', value: 54 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.55', value: 55 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.56', value: 56 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.57', value: 57 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.58', value: 58 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.59', value: 59 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_PIPE_SECTION.60', value: 60 },
    //     ]
    //   }
    // },
    // {
    //   name: 'wtcOldestElectricalPart', key: 'WTC_OLDEST_ELECTRICAL_PART', group: 'OBJECT_INFO',
    //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    //   validator: ['', [
    //     Validators.required
    //   ]],
    //   settings: {
    //     list: [
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.0', value: 0 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.1', value: 1 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.2', value: 2 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.3', value: 3 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.4', value: 4 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.5', value: 5 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.6', value: 6 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.7', value: 7 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.8', value: 8 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.9', value: 9 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.10', value: 10 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.11', value: 11 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.12', value: 12 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.13', value: 13 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.14', value: 14 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.15', value: 15 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.16', value: 16 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.17', value: 17 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.18', value: 18 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.19', value: 19 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.20', value: 20 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.21', value: 21 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.22', value: 22 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.23', value: 23 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.24', value: 24 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.25', value: 25 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.26', value: 26 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.27', value: 27 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.28', value: 28 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.29', value: 29 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.30', value: 30 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.31', value: 31 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.32', value: 32 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.33', value: 33 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.34', value: 34 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.35', value: 35 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.36', value: 36 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.37', value: 37 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.38', value: 38 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.39', value: 39 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.40', value: 40 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.41', value: 41 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.42', value: 42 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.43', value: 43 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.44', value: 44 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.45', value: 45 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.46', value: 46 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.47', value: 47 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.48', value: 48 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.49', value: 49 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.50', value: 50 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.51', value: 51 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.52', value: 52 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.53', value: 53 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.54', value: 54 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.55', value: 55 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.56', value: 56 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.57', value: 57 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.58', value: 58 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.59', value: 59 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.60', value: 60 },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_OLDEST_ELECTRICAL_PART.60+', value: '60+' },
    //     ]
    //   }
    // },
    { name: 'wtcRentalNumberApartments', key: 'WTC_RENTAL_NUMBER_APARTMENTS', group: 'INSURANCE_INFO' },
    { name: 'wtcMonthlyRentalIncome', key: 'WTC_MONTHLY_RENTAL_INCOME', group: 'INSURANCE_INFO', },
    { name: 'houseWithContents', key: 'HOUSE_WITH_CONTENTS', group: 'INSURANCE_INFO',
      values: [
        {
          name: 'deductible',
          key: 'DEDUCTIBLE',
          group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.5', value: 5000 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.75', value: 7500 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.10', value: 10000 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.15', value: 15000 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.20', value: 20000 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.25', value: 25000 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.30', value: 30000 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.50', value: 50000 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.100', value: 100000 }
            ]
          }
        },
        { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ELITE', value: 'SUPER' }
            ]
          }
        },
        {
          name: 'productSumInsured',
          key: 'HOUSE_CONTENT_SUM_INSURED',
          inputType: INPUT_TYPES_CONFIG.TEL,
          validator: ['', [
            Validators.required
          ]],
        }
      ]
    },
    { name: 'houseAdditionalBuildings', key: 'HOUSE_ADDITIONAL_BUILDINGS', group: 'OBJECT_INFO',
      values: [
        // { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
        //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        //   validator: ['', [
        //     Validators.required
        //   ]],
        //   settings: {
        //     list: [
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.5', value: 5000 },
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.75', value: 7500 },
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.10', value: 10000 },
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.15', value: 15000 },
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.20', value: 20000 },
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.25', value: 25000 },
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.30', value: 30000 },
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.50', value: 50000 },
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.100', value: 100000 }
        //     ]
        //   }
        // },
        { name: 'houseSumInsuredType', key: 'SUM_INSURED_TYPE', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          isFirstRiskSumInsuredCheck: true,
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
            ]
          }
        },
        { name: 'houseFirstRiskSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
        { name: 'wtcBuildingValueStandard', key: 'BUILDING_VALUE_STANDARD', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_VALUE_STANDARD.NORMAL', value: 'Normal' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_VALUE_STANDARD.BETTER', value: 'Bedre' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_VALUE_STANDARD.HIGH_STANDARD', value: 'Svært høy standard' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_VALUE_STANDARD.EXCLUSIV', value: 'Eksklusiv' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_VALUE_STANDARD.UNDERWRITER', value: 'Underwriter' }
            ]
          }
        },
        {
          name: 'houseBuildingType',
          key: 'BUILDING_TYPE',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_SHED_NOT_ISOLATED', value: 'SHED_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_SHED_ISOLATED', value: 'SHED_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_GARAGE_ISOLATED', value: 'GARAGE_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_GARAGE_NOT_ISOLATED', value: 'GARAGE_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CARPORT', value: 'CARPORT' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_LOGCABIN_MACHINE', value: 'LOGCABIN_MACHINE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_LOGCABIN_BY_HAND', value: 'LOGCABIN_BY_HAND' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_ROW_GARAGE', value: 'ROW_GARAGE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_LOGCABIN_NOT_ISOLATED', value: 'LOGCABIN_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_ANNEX', value: 'ANNEX' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_BOAT_HOUSE_ISOLATED', value: 'BOAT_HOUSE_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_BOAT_HOUSE_NOT_ISOLATED', value: 'BOAT_HOUSE_NOT_ISOLATED' },
            ]
          }
        },
        { name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.NUMBER,
          validator: ['', [
            Validators.required
          ]]
        },
      ]
    },
    { name: 'houseSMAutomaticCircuitBreaker', key: 'HOUSE_SM_AUTOMATIC_CIRCUIT_BREAKER', group: 'OBJECT_INFO' },
    { name: 'houseSurgeProtectionInFuseCabinet', key: 'HOUSE_SURGE_PROTECTION_IN_FUSE_CABINET', group: 'OBJECT_INFO' }
  ],
  icon: 'house'
};
